import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Spinner from "../../Spinner/spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Button } from "reactstrap";
import CustomModal from "./reasignacionModal";
import { Helmet } from "react-helmet";
import { localeEs } from "../../locale/ag-grid-es";
import BreadCrum from "../../breadCrum/breadCrum";
import withTokenCheck from "../../withTokenCheck";

const AppReasignacion = ({ token }) => {
    const [data, setData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const gridApi = useRef(null);
    const [loading, setLoading] = useState(true);
    const etiquetas = [
        "Inicio Lossman",
        "Cambios De Evento",
        "Reasignación De Camas",
    ];

    useEffect(() => {
        if (token) {
            axios
                .get("/asignacion/reporte/reasignaciones", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setData(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [token]);

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    const columnDefs = [
        {
            field: "id",
            headerName: "Reasignar Cama",
            cellRenderer: (params) => (
                <Button
                    color="secondary"
                    onClick={() => handleButtonClick(params.data)}
                >
                    Reasignar Cama
                </Button>
            ),
        },
        {
            field: "NumeroCaso",
            headerName: "Numero Caso",
        },
        {
            field: "FechaInicial",
            headerName: "Fecha Inicial",
        },
        {
            field: "FechaFinal",
            headerName: "Fecha Final",
        },
        {
            field: "Texto",
            headerName: "Tipo de usuario",
        },
        {
            field: "Persona",
            headerName: "Nombre",
        },
        {
            field: "TipoDocumento",
            headerName: "Tipo de documento",
        },
        {
            field: "Documento",
            headerName: "Numero Documento",
        },
        {
            field: "NumeroHabitacion",
            headerName: "Cama Asignada",
        },
        {
            field: "created_by.name",
            headerName: "Usuario que asigno",
        },
        {
            field: "created_by.created_at",
            headerName: "Fecha Asignación",
        },
    ];

    const handleModalToggle = () => setModalOpen(!modalOpen);

    const handleButtonClick = (content) => {
        setModalContent(content);
        handleModalToggle();
    };

    const handleExportCSV = () => {
        gridApi.current.exportDataAsCsv();
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const handleUpdateTable = () => {
        setLoading(true);
        if (token) {
            axios
                .get("/asignacion/reporte/reasignaciones", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setData(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return (
        <>
            <Helmet>
                <title>Reasginación Cama</title>
            </Helmet>
            <div style={{ position: "relative" }}>
                {loading && <Spinner />}
                <div>
                    <BreadCrum etiquetas={etiquetas} />
                </div>
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                    <div className="container-fluid mt-5">
                        <Button color="success" onClick={handleExportCSV}>
                            Exportar CSV (Excel)
                        </Button>
                        <div
                            className="mt-3"
                            style={{ height: "500px", width: "100%" }}
                        >
                            <div
                                className="ag-theme-alpine"
                                style={{ height: "100%", width: "100%" }}
                            >
                                <AgGridReact
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CustomModal
                isOpen={modalOpen}
                toggle={handleModalToggle}
                infoModal={modalContent}
                footer={modalContent.footer}
                token={token}
                updateTable={handleUpdateTable}
            />
        </>
    );
};

export default withTokenCheck(AppReasignacion);
